module.exports = __webpack_public_path__ + "img/community.6706e1b.svg";